// extracted by mini-css-extract-plugin
module.exports = {"groupTable":"Group_groupTable___1dzu","levelTitle":"Group_levelTitle__3Ivui"};